"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultHierarchyLevelByCurriculum = exports.getStandardCodeFromItemStandard = exports.getShortCodeFromGlobalIds = exports.getShortCodeFromGlobalId = void 0;
var dp_standards_helper_lib_1 = require("@greatmindsorg/dp-standards-helper-lib");
var uniq_1 = __importDefault(require("lodash/uniq"));
var constants_1 = require("../constants");
var standard_hierarchy_level_enum_1 = require("../constants/standard-hierarchy-level.enum");
var getShortCodeFromGlobalId = function (globalId) {
    return (0, dp_standards_helper_lib_1.getShortCodeFromGlobalId)(globalId);
};
exports.getShortCodeFromGlobalId = getShortCodeFromGlobalId;
var getShortCodeFromGlobalIds = function (globalIds) {
    return globalIds.map(function (standard) { return (0, exports.getShortCodeFromGlobalId)(standard); });
};
exports.getShortCodeFromGlobalIds = getShortCodeFromGlobalIds;
var getStandardCodeFromItemStandard = function (assessmentTemplateItemStandards) {
    var standards = [];
    var itemStandards = [];
    (assessmentTemplateItemStandards || []).forEach(function (assessmentTemplateItemStandard) {
        assessmentTemplateItemStandard.itemStandards.forEach(function (item) {
            var _a;
            itemStandards.push(item);
            standards = standards.concat((_a = item.standardGlobalIds) === null || _a === void 0 ? void 0 : _a.map(function (longId) { return longId; }));
        });
    });
    standards = standards.filter(function (standard) { return !!standard; }); // remove falsy values from array (eg. V2 Standards do not have global ids)
    return {
        itemStandards: itemStandards,
        standards: (0, uniq_1.default)(standards),
    };
};
exports.getStandardCodeFromItemStandard = getStandardCodeFromItemStandard;
var getDefaultHierarchyLevelByCurriculum = function (curriculumId) {
    switch (curriculumId) {
        case constants_1.CurriculumId.EurekaMath:
            return standard_hierarchy_level_enum_1.StandardHierarchyLevel.Standard;
        case constants_1.CurriculumId.EurekaMathTX:
            return standard_hierarchy_level_enum_1.StandardHierarchyLevel.KnowledgeSkill;
        case constants_1.CurriculumId.WitAndWisdom:
            return standard_hierarchy_level_enum_1.StandardHierarchyLevel.GradeLevelStandard;
        default:
            return standard_hierarchy_level_enum_1.StandardHierarchyLevel.Standard;
    }
};
exports.getDefaultHierarchyLevelByCurriculum = getDefaultHierarchyLevelByCurriculum;
